'use client'

import {useMantineColorScheme} from '@blocks'
import {useDidUpdate, useIsomorphicEffect} from '@hooks'

export const FaviconSynchronizer = () => {
   const {colorScheme} = useMantineColorScheme()

   const removeExistingLinks = (relValues: string[]) => {
      const selector = relValues
         .map((rel) => `link[rel="${rel}"]`)
         .join(', ')
      document.head
         .querySelectorAll<HTMLLinkElement>(selector)
         .forEach((node) => {
            node.remove()
            return
         })
   }

   const createLink = (
      rel: string,
      href: string,
      attributes: Record<string, string> = {}
   ) => {
      const link = document.createElement('link')
      link.rel = rel
      link.href = href
      Object.entries(attributes).map(([key, value]) =>
         link.setAttribute(key, value)
      )
      document.head.appendChild(link)
   }

   const handleLoadThemedIcon = (iconPath: string) => {
      try {
         removeExistingLinks([
            'icon',
            'shortcut icon',
            'apple-touch-icon',
            'mask-icon'
         ])
         createLink('icon', iconPath, {type: 'image/svg+xml'})
      } catch {
         return
      }
   }

   useIsomorphicEffect(() => {
      handleLoadThemedIcon(
         `/assets/kodra-icon-${colorScheme}-padded.svg`
      )
   }, [colorScheme])

   useDidUpdate(() => {
      handleLoadThemedIcon(
         `/assets/kodra-icon-${colorScheme}-padded.svg`
      )
   }, [colorScheme])

   return null
}
